/**
 * FlowupLabels - Vanilla JS replacement for jQuery FlowupLabels plugin.
 * Adds 'focused' and 'populated' classes to form groups for floating label effects.
 */
function initFlowupLabels(selector, options) {
  const defaults = {
    feature_onInitLoad: true,
    class_focused: 'focused',
    class_populated: 'populated'
  };
  const settings = Object.assign({}, defaults, options);

  document.querySelectorAll(selector).forEach(function(form) {
    form.addEventListener('focusin', function(e) {
      if (e.target.matches('.input-text, .form-control')) {
        var group = e.target.closest('.form-row, .form-group, .floating_input');
        if (group) group.classList.add(settings.class_focused);
      }
    });

    form.addEventListener('focusout', function(e) {
      if (e.target.matches('.input-text, .form-control')) {
        var group = e.target.closest('.form-row, .form-group, .floating_input');
        if (!group) return;
        if (e.target.value.length) {
          group.classList.add(settings.class_populated);
          group.classList.remove(settings.class_focused);
        } else {
          group.classList.remove(settings.class_populated, settings.class_focused);
        }
      }
    });

    if (settings.feature_onInitLoad) {
      form.querySelectorAll('.input-text, .form-control').forEach(function(input) {
        var group = input.closest('.form-row, .form-group, .floating_input');
        if (group && input.value.length) {
          group.classList.add(settings.class_populated);
        }
      });
    }
  });
}
